import OLMap from 'ol/Map';
import DragPan from 'ol/interaction/DragPan';
import DragZoom from 'ol/interaction/DragZoom';

export function getDragPan(map: OLMap) {
  const interactions = map.getInteractions();

  for (let i = 0; i < interactions.getLength(); i++) {
    const interaction = interactions.item(i);
    if (interaction instanceof DragPan) {
      return interaction;
    }
  }

  return null;
}

export function getDragZoom(map: OLMap) {
  const interactions = map.getInteractions();

  for (let i = 0; i < interactions.getLength(); i++) {
    const interaction = interactions.item(i);
    if (interaction instanceof DragZoom) {
      return interaction;
    }
  }

  return null;
}
